const appLoaderStyle = {
  appLoader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -20,
    marginLeft: -20,
    fontSize: 40
  }
}

export default appLoaderStyle
